import { request } from './repository';

const url = 'service-categories/'

const sourceServiceCategoryRepository = {
    getSourceServiceCategories(params) {
        return request.get(url, params);
    },
    storeSourceServiceCategory(data) {
        return request.post(url, data);
    },
    updateSourceServiceCategory(id, data) {
        return request.put(url + id, data);
    },
    deleteSourceServiceCategory(id) {
        return request.delete(url + id);
    }
}

export default sourceServiceCategoryRepository;